import { c as _c } from "react/compiler-runtime";
import { AutoLinkPlugin } from '@lexical/react/LexicalAutoLinkPlugin';
import * as React from 'react';

// https://regex101.com/r/RvAeHG/2
export const URL_MATCHER = /([a-z]{3,5}:\/\/[0-9a-z\.\-:_+%]+(\/[^\s\?#\]]*)?(\?[^\s\?#\)\]]*)?(#[\S]*)*)/;
export const EMAIL_MATCHER = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
export const MATCHERS = [(text: string) => {
  const match = URL_MATCHER.exec(text);
  if (match === null || !match[0]) return null;
  const fullMatch = match[0];
  return {
    index: match.index,
    length: fullMatch.length,
    text: fullMatch,
    url: fullMatch.startsWith('http') ? fullMatch : `https://${fullMatch}`
  };
}, (text: string) => {
  const match = EMAIL_MATCHER.exec(text);
  if (match === null || !match[0]) return null;
  return match && {
    index: match.index,
    length: match[0].length,
    text: match[0],
    url: `mailto:${match[0]}`
  };
}];

// in Readonly mode, make all links open in new window
export default function SAutoLinkPlugin() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AutoLinkPlugin matchers={MATCHERS} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}